<template>
  <section class="slider">
    <div class="sidebar" :style="{
      top: '-270vh'
    }">
      <div style="background: linear-gradient(229.99deg, #f8e9a1 -26%, saddlebrown 145%);">
        <p>Наши работы выполняются согласно строительным нормам и правилам. Сервисная служба ООО "ОБЛГАЗСЕРВИС-СЕВЕР" аттестована и допущена Гостехнадзором и Госстроем России к монтажу, наладке, сервисному обслуживанию и ремонту газового оборудования. </p>
      </div>
      <div style="background: linear-gradient(215.32deg, #f4976c -1%, #f76c6c 124%);">
        <p>Наше кредо: "Высокое качество и профессионализм". Мы предоставляем полный спектр услуг: начиная с проектирования котельной; установки, монтажа оборудования и, в дальнейшем, осуществляем сервисное обслуживание и техническую поддержку.</p>
      </div>
      <div style="background: linear-gradient(221.87deg, darkgray 1%, black 128%);">
        <p>Мы работаем с самым современным оборудованием ведущих зарубежных компаний: <span class="company">VAILLANT</span> (Германия <span><img
            src="../img/germany.webp" alt="флаг германии"></span>), <span class="company">VIESSMANN</span> (Германия <span><img
            src="../img/germany.webp" alt="флаг германии"></span>), <span class="company">SIME</span> (Италия <span><img
            src="../img/italy.webp" alt="флаг италии"></span>), <span class="company">PROTHERM</span> (Чехия <span><img
            src="../img/czech.webp" alt="флаг чехии"></span>)</p>
      </div>
      <div style="background: linear-gradient(220.16deg, deepskyblue -8%, #a8d0e6 100%);">
        <p>В нашей компании работает высококвалифицированный и обученный персонал, чей многолетний опыт работы позволяет профессионально решать любые задачи в заданные сроки. </p>
      </div>
    </div>
    <div class="main-slide">
      <img  src="../img/arms.webp" alt="рукопожатие">
      <img  src="../img/valliant.webp" alt="красивая котельная комната">
      <img  src="../img/man-service.webp" alt="сервис">
      <img  src="../img/law.webp" alt="всё по закону">
    </div>
    <div class="controls">
      <button class="down-button" @click="changeSlide('down')">
        <i class="fas fa-arrow-down"></i>
      </button>
      <button class="up-button" @click="changeSlide('up')">
        <i class="fas fa-arrow-up"></i>
      </button>
    </div>
  </section>
</template>

<script>
    import {ref} from "vue";

    export default {
      setup() {

        let activeSlideIndex = ref(0)
        let slidesCount = ref(4)

        function changeSlide(direction) {
          if (direction === 'up') {
            activeSlideIndex.value++
            if (activeSlideIndex.value === slidesCount.value) {
              activeSlideIndex.value = 0
            }
          } else if (direction === 'down') {
            activeSlideIndex.value--
            if (activeSlideIndex.value < 0) {
              activeSlideIndex.value = slidesCount.value - 1
            }
          }

          const container = ref(document.querySelector('.slider'))
          const mainSlide = ref(document.querySelector('.main-slide'))
          const sidebar = ref(document.querySelector('.sidebar'))
          const height = ref(container.value.clientHeight)

          mainSlide.value.style.transform = `translateY(-${activeSlideIndex.value * height.value}px)`
          sidebar.value.style.transform = `translateY(${activeSlideIndex.value * height.value}px)`
        }

        return {
          activeSlideIndex,
          slidesCount,
          changeSlide
        }
      }
    }
</script>

<style scoped>

@import url('https://fonts.googleapis.com/css?family=Roboto&display=swap');

body {
  font-family: 'Roboto', sans-serif;
  height: 100vh;
}

.slider {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  width: 99.3vw;
  height: 90vh;
}

.sidebar {
  height: 100%;
  width: 35%;
  position: absolute;
  top: 0;
  left: 0;
  transition: transform 0.5s ease-in-out;
}

.sidebar > div {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.sidebar p {
  font-size: 2em;
  margin: -30px 5% 10px;
  text-align: center;
}

.main-slide {
  height: 100%;
  position: absolute;
  top: 0;
  left: 35%;
  width: 65%;
  transition: transform 0.5s ease-in-out;
}

.main-slide > img {
  display: block;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  height: 100%;
  width: 100%;
}

button {
  background-color: white;
  border: none;
  color: #ffffff;
  cursor: pointer;
  font-size: 16px;
  padding: 15px;
}

button:hover {
  color: orange;
}

button:focus {
  outline: none;
}

.slider .controls button {
  position: absolute;
  left: 35%;
  top: 50%;
  z-index: 10;
}

.slider .controls .down-button {
  height: 40px;
  width: 40px;
  background-image: url("../img/arrowDOWN.png");
  background-size: contain;
  transform: translateX(-100%);
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.slider .controls .up-button {
  height: 40px;
  width: 40px;
  background-image: url("../img/arrowUP.png");
  background-size: contain;
  transform: translateY(-100%);
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.company {
  color: #111111;
  font-weight: 900;
}

h1 {
  text-align: center;
  padding: 40px;
}

img {
  height: 48px;
  width: 48px;
}

@media (max-width: 1400px) {
  .main-slide {
    display: none;
  }

  .sidebar {
    width: 100%;
  }

  .slider .controls button {
    left: 50%;
    top: 10%;
    z-index: 10;
  }

  .slider .controls .down-button {
    transform: translateX(0);
    border-radius: 10px;
  }

  .slider .controls .up-button {
    transform: translateX(-150%);
    border-radius: 10px;
  }
}

@media (max-width: 900px) {

 .sidebar h1 {
    font-size: 24px;
  }

  .sidebar p {
    font-size: 25px;
  }

  .slider .controls button {
    left: 5%;
    top: 30%;
    z-index: 10;
  }

  .slider .controls .down-button {
    transform: translateY(800%) translateX(200%);
    border-radius: 10px;
  }

  .slider .controls .up-button {
    transform: translateY(800%);
    border-radius: 10px;
  }
}

@media (max-width: 400px) {
  .sidebar p {
    font-size: 20px;
  }

  .slider .controls .down-button {
    height: 30px;
    width: 30px;
  }

  .slider .controls .up-button {
    height: 30px;
    width: 30px;
  }
}

@media (max-height: 600px) {
  .slider .controls .down-button {
    transform: translateY(700%) translateX(200%);
    border-radius: 10px;
  }

  .slider .controls .up-button {
    transform: translateY(700%);
    border-radius: 10px;
  }
}
</style>